var SmallModal = require('./lib/small-modal'),
    MediumModal = require('./lib/medium-modal'),
    LargeModal = require('./lib/large-modal');

module.exports = {
    SmallModal: SmallModal,
    MediumModal: MediumModal,
    LargeModal: LargeModal
};



//////////////////
// WEBPACK FOOTER
// ./~/deere-ui-modal-core/index.js
// module id = 1003
// module chunks = 0